import { createSelector } from 'reselect'
import { userCredentialsSelector } from 'redux/selectors/user'
import activityTypes from 'helpers/enums/activityTypes'
import { getActivityPayload } from 'redux/reducers/helpers/interactiveVideo/activities'

const interactiveVideoData = state => state.interactiveVideo

export default createSelector(
	[ interactiveVideoData, userCredentialsSelector],
	( interactiveVideo, userCredentials ) => ({
		jwt: userCredentials.interactiveVideo,
		mediaSessionUid: interactiveVideo.uid,
		participantUid: interactiveVideo.participantUid,
		activityUids: getOeqActivitiesUids(interactiveVideo.activities),
	})
)

function getOeqActivitiesUids(activities) {
	return activities.reduce(
		(questionUids, activity) => {
			if (activity.type === activityTypes.OPEN_ENDED_QUESTION) {
				questionUids.push(getActivityPayload(activity).uid)
			}
			return questionUids
		}, []
	)
}
